import { Component, input } from '@angular/core';
import { AdvertViewModel } from '@models/advert/advert';
import { ViewUnitIntranetComponent } from '../../view-unit-intranet/view-unit-intranet.component';
import { ViewUnitAcmComponent } from '../../view-unit-acm/view-unit-acm.component';
import { TranslateModule } from '@ngx-translate/core';
import { NumeralPipe } from '../../../../pipes/numeral.pipe';
import { ConvertDatePipe } from '@pipes/convert-date.pipe';

@Component({
    selector: 'parking-space-header-stats',
    templateUrl: './parking-space-header-stats.component.html',
    imports: [ViewUnitIntranetComponent, ViewUnitAcmComponent, TranslateModule, NumeralPipe, ConvertDatePipe]
})
export class ParkingSpaceHeaderStatsComponent {
    readonly advert = input<AdvertViewModel>(undefined);
}
